import * as React from 'react';
import { useWheelStopPropagation } from 'owa-react-hooks/lib/useWheelStopPropagation';
import type { AgendaViewProps } from '../components/AgendaView';
import {
    AgendaListPayload,
    isOnDateUpdatedAgendaListPayload,
    updateSelectedDate,
} from 'owa-agenda-events-list';
import { assertNever } from 'owa-assert';
import { useCalendarEventInteractionCallbacks } from '../hooks/useCalendarEventInteractionCallbacks';
import { convertToOwaDate } from '../utils/dateUtils';
import { asDate } from 'owa-datetime';

export default function useDayViewViewState({
    scenarioId,
    onDateUpdated,
    selectedDate,
    onClickCalendarEvent,
    onContextMenuInvoked,
}: AgendaViewProps) {
    const ref = React.useRef<HTMLDivElement | null>(null);
    useWheelStopPropagation(ref);

    const onAgendaListCallback = React.useCallback(
        (payload: AgendaListPayload) => {
            if (isOnDateUpdatedAgendaListPayload(payload)) {
                onDateUpdated(asDate(payload.date));
            } else {
                assertNever(payload);
            }
        },
        [onDateUpdated]
    );

    const calendarEventInteractionCallbacks = useCalendarEventInteractionCallbacks(
        selectedDate,
        onClickCalendarEvent,
        onContextMenuInvoked
    );

    const onSelectDate = React.useCallback((selectedDate: Date) => {
        const owaDate = convertToOwaDate(selectedDate);
        updateSelectedDate(owaDate, scenarioId);
        onDateUpdated(selectedDate);
    }, []);

    return {
        ref: ref,
        onAgendaListCallback: onAgendaListCallback,
        calendarEventInteractionCallbacks: calendarEventInteractionCallbacks,
        onSelectDate: onSelectDate,
    };
}
